import { pageNames } from '@/enums/pageNames'
import router from '@/router'
import { baseNotifStore } from '@/stores/notification/baseNotif'
import type { AxiosError, AxiosResponse } from 'axios'
import axios from 'axios'

const BASE_URL: string = import.meta.env.VITE_BASE_URL
const TOKEN: string = import.meta.env.VITE_APP_TOKEN


const instance = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: {
    Authorization: TOKEN
  }
})

instance.interceptors.response.use(
  (response: AxiosResponse) => {
    return response
  },
  (error: AxiosError) => {
    if (
      error.response?.status === 401 &&
      router.currentRoute.value.name !== pageNames.LOGIN &&
      router.currentRoute.value.name !== pageNames.FORGOTPASSWORD &&
      router.currentRoute.value.name !== pageNames.RESETPASSWORD
    ) {
      const baseNotif = baseNotifStore()
      baseNotif.setNotiTitle('Session expired!')
      baseNotif.setNotiLabel('Please signin back to access your dashboard.')
      baseNotif.setErrorNotifState(true)
      setTimeout(() => baseNotif.setErrorNotifState(false), 4000)
      router.replace({ name: pageNames.LOGIN })
      return router.replace({ name: pageNames.LOGIN })
    }
    return error.response
  }
)

export default instance
